import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss']
})
export class MessageDialogComponent {
  message = '';
  confirmButtonText = 'OK';

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: any,
    public readonly dialogRef: MatDialogRef<MessageDialogComponent>
  ) {
    if (data) {
      this.message = data.message || this.message;
      if (data.buttonText) {
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
      }
    }
  }

  get injectedData() {
    return this.data;
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
